import { jsx } from "react/jsx-runtime";
import { iconFactory } from "./Icon.js";
const IconChevron = iconFactory('IconChevron', /*#__PURE__*/ jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-icon-type": "fill",
    children: /*#__PURE__*/ jsx("path", {
        d: "M9.7496212,4.5 L9.7496212,11.999 L17.2496212,12 L17.2496212,15 L9.7496212,14.999 L9.7496212,15 L6.7496212,15 L6.7496212,4.5 L9.7496212,4.5 Z",
        transform: "rotate(-45 12 9.75)"
    })
}));
export { IconChevron };
